import { render, staticRenderFns } from "./UploadNexus.vue?vue&type=template&id=4e2fb1fc&scoped=true"
import script from "./UploadNexus.vue?vue&type=script&lang=ts"
export * from "./UploadNexus.vue?vue&type=script&lang=ts"
import style0 from "./UploadNexus.vue?vue&type=style&index=0&id=4e2fb1fc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2fb1fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e2fb1fc')) {
      api.createRecord('4e2fb1fc', component.options)
    } else {
      api.reload('4e2fb1fc', component.options)
    }
    module.hot.accept("./UploadNexus.vue?vue&type=template&id=4e2fb1fc&scoped=true", function () {
      api.rerender('4e2fb1fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/UploadNexus.vue"
export default component.exports